<template>
  <div class="">
    <header class="flex-between">
      <div class="">
        <div class="clinic-box">
          <div class="">
            <h1 v-if="session.currentClinic">
              {{ session.currentClinic.name }}
            </h1>

            <button class="btn-icon" type="button" name="button" data-test="btnChangeClinic" @click="openChangeOffcanvas">
              <IconChange/>
            </button>
          </div>

          <div class="">
            <p>
              powered by
            </p>
            <img class="logo dark-logo" src="@/assets/images/phelcom/eyercloud_logo.svg" alt="Eyercloud logo" width="52">
            <img class="logo light-logo" src="@/assets/images/phelcom/eyercloud_logo_white.svg" alt="Eyercloud logo" width="52">
          </div>

        </div>

      </div>
      <div class="search-box" :class="{'open': headerPatientList.length || isExamFilter || showLatestResults}" ref="searchBox" v-if="!isSpecialist">
        <div class="form-group">
          <IconSearchFilter/>
          <input class="form-control"
                 type="text"
                 name="search"
                 v-model="searchValue"
                 v-if="!isExamFilter && !isSpecialist"
                 :placeholder="isExamFilter ? $t('patientSearch.searchPatientExam') : $t('patientSearch.search')"
                 @keyup="doSearch($event)"
                 @keypress.enter.prevent.stop="showAllSearchedPatients"
                 @click="handleInputClick"
                 @close="isLoadingPatients = false"
                 @keydown.left.stop="void 0"
                 @keydown.right.stop="void 0"
                 :disabled="isLoadingPatients">

          <p class="no-margin" v-else>{{ $t('exam.filterExams') }}</p>

          <IconClose class="clear-search" v-if="searchValue" @click="clearSearchValue"/>
          <div class="search-box-actions" v-if="isExamRoute">
            <IconFilter v-if="!isExamFilter" @click="toggleExamFilter"/>
            <IconClose v-else @click="toggleExamFilter"/>
          </div>
        </div>

        <div class="list-group-box" v-if="headerPatientList.length || showLatestResults">
          <div class="" v-if="showLatestResults">
            <button class="btn btn-square" type="button" name="button" @click="doFilterExamListLastSevenDays()">
              {{ $t('patientSearch.lastSevenDays') }}
            </button>

            <!-- <button class="btn btn-square" type="button" name="button" @click="doFilterExamListByEyerMaps()">
              EyerMaps
            </button> -->

            <ul class="last-search-list">
              <li>
                <IconClock/>
                <p>Aguiar de Souza</p>
              </li>
              <li>
                <IconClock/>
                <p>Maria</p>
              </li>
              <li>
                <IconClock/>
                <p>Bruno</p>
              </li>
              <li>
                <IconClock/>
                <p>Ricardo</p>
              </li>
              <li>
                <IconClock/>
                <p>Augusto</p>
              </li>
            </ul>
          </div>

          <div class="patient-list-box" v-if="headerPatientList.length">
            <ul class="list-group scrollbar">
              <li class="list-group-item" v-for="item in headerPatientList" @click="doFilterExamListByPatientID(item)">
                <IconPatientsSearch/>

                <div class="">
                  <p>{{ item.fullName }}</p>

                  <div class="id-box">
                    <div class="icon-sub"></div>
                    <span>{{ $utils.getFormattedPatientDocumentWithSearchMatch(item, searchValue, $i18n) }}</span>
                  </div>
                </div>

                <small>{{ formatDate(item.lastExamDate) }}</small>
              </li>
            </ul>

            <div class="search-all-box">
              <IconSearchFilter/>

              <p>{{ $t('patientSearch.searchAll') }}<strong>{{ searchValue }}</strong></p>

              <small>{{ $t('patientSearch.pressEnter') }}</small>
            </div>
          </div>

        </div>

        <div class="exam-filter-box" v-if="isExamFilter" id="examFilterBox">
          <ExamFilter v-if="isExamRoute" @close="toggleExamFilter"
                      :currentProperties="examFilterStore.filter.filter.properties"
                      :currentDates="{ startDate: examFilterStore.filter.filter.startDate, endDate: examFilterStore.filter.filter.endDate }"/>
        </div>
      </div>

      <div class="">
        <!-- <div class="storage-box flex-center" v-if="isPaidService">
          <p>plano gratuito</p>
          <MenuStorageBar/>
        </div> -->

        <MenuProfile></MenuProfile>

        <a class="btn btn-outline-secondary" :href="helpcenterUrl" target="_blank">{{ $t('menu.help') }}</a>
      </div>
    </header>

    <div class="header-filter-box" v-show="hasFilterItems && isExamRoute && !isSmallScreen">
      <p>{{ $t('patientSearch.searchingFor') }}</p>

      <span id="tag_patient" data-value="patient" class="tag2 alert" v-if="currentFilter.patientID">
        <span>{{ patientFullName }}</span>
        <a href="#" @click="clearFilteredList('name')">
          <IconCross/>
        </a>
      </span>

      <span id="tag_date" data-value="date" class="tag2 alert" v-if="currentFilter.startDate || currentFilter.endDate">
        <span>{{ `${currentFilter.startDate} ${$t('until')} ${currentFilter.endDate}` }}</span>
        <a href="#" @click="clearFilteredList('date')">
          <IconCross/>
        </a>
      </span>

      <template v-for="(item, key) in currentFilter.properties" :key="key">
        <span :id="`tag_${key}`" :data-value="key" class="tag2 alert" v-if="item">
          <span>{{ $t(`patientSearch.${key}`) }}</span>
          <a href="#" @click="clearFilteredList(key)">
            <IconCross/>
          </a>
        </span>
      </template>

      <button class="btn btn-outline-secondary" type="button" name="button" @click="clearFilteredList('all')">{{ $t('patientSearch.cleanFilters') }}</button>
    </div>

    <teleport to="body">
      <ClinicChangeOffcanvas v-if="!isSmallScreen" :offcanvas_id="'ClinicChangeOffcanvas'" ref="clinicChangeOffcanvas"/>
      <PatientListSearchedOffcanvas :offcanvas_id="'PatientListSearchedHeaderOffcanvas'" ref="patientListSearchedHeaderOffcanvas" @patient-selected="doFilterExamListByPatientID"/>
    </teleport>
  </div>
</template>

<style lang="scss" scoped>
.header-filter-box {
  display:                        flex;
  flex-direction:                 row;
  justify-content:                flex-start;
  align-items:                    center;
  gap:                            15px;
  padding:                        10px 20px;

  p {
    color:                        var(--Shades-50);
    font-size:                    var(--font-size-14);
    font-weight:                  400;
    line-height:                  normal;
    letter-spacing:               0.7px;
    margin:                       0;
  }

  .tag2 {
    padding:                      5px 5px 5px 10px;
    background:                   var(--Shades-10);

    span {
      color:                      var(--Shades-90);
      font-size:                  var(--font-size-14);
      font-weight:                400;
      line-height:                normal;
      letter-spacing:             0.7px;
    }
  }

  .btn-outline-secondary {
    color:                        var(--Brand-Primary);
    font-size:                    11px;
    font-weight:                  500;
    line-height:                  normal;
    letter-spacing:               1.65px;
    padding:                      7px 10px;
  }
}

.last-search-list {
  width:                          100%;
  padding:                        0;
  gap:                            10px;

  li {
    display:                      flex;
    align-items:                  center;
    align-self:                   stretch;
    gap:                          10px;
    padding:                      5px;
    margin:                       0 !important;
    border:                       0 !important;
  }
}

.icon-sub {
  @include                        border_radius(1px);
  width:                          8px;
  height:                         8px;
  border-left:                    1.5px solid var(--Shades-30);
  border-bottom:                  1.5px solid var(--Shades-30);
}

header {
  position:                       relative;
  align-self:                     stretch;
  gap:                            20px;
  height:                         62px;
  width:                          100%;
  padding-right:                  20px;
  padding-left:                   20px;
  z-index:                        1039;

  h1 {
    font-size:                    var(--font-size-22);
    font-weight:                  500;
    line-height:                  normal;
    letter-spacing:               1.1px;
    white-space:                  nowrap;
    text-overflow:                ellipsis;
    overflow:                     hidden;
    background:                   linear-gradient(90deg, #1B294A 0.02%, #3CB391 99.98%);
    background-clip:              text;
    -webkit-background-clip:      text;
    -webkit-text-fill-color:      transparent;
    width:                        100%;
    max-width:                    600px;
    margin-bottom:                5px;
  }

  p {
    color:                        var(--Shades-40);
    font-size:                    var(--font-size-8);
    font-weight:                  500;
    line-height:                  normal;
    letter-spacing:               1.12px;
    text-transform:               uppercase;
    text-overflow:                ellipsis;
    overflow:                     hidden;
    margin:                       0 6px 0 0;
  }

  > div {
    display:                      flex;
    justify-content:              flex-end;
    align-items:                  center;

    &:first-child {
      display:                    flex;
      flex-direction:             row;
      justify-content:            space-between;
      gap:                        30px;

      .clinic-box {
        display:                  flex;
        flex-wrap:                wrap;
        flex-direction:           column;
        justify-content:          flex-start;
        align-items:              flex-start;
        width:                    auto;

        > div {
          display:                flex;
        }

        .btn-icon {
          padding:                4px !important;
          display:                flex;
          align-items:            center;
          justify-content:        center;
          width:                  30px;
          height:                 30px;
          background:             var(--Shades-W);
          border:                 1px solid var(--Shades-30-Border);

          svg {
            width:                20px;
            height:               20px;
          }
        }
      }

      .btn-icon {
        font-size:                14px;
        background-color:         #727272;
        padding:                  3px 6px;
        width:                    30px;
        height:                   30px;
        border:                   unset;
        line-height:              0;
        svg {
          width:                  22px;
        }
      }
    }

    &:last-child {
      .btn-outline-secondary {
        margin-left:              15px;
      }
    }
  }

  .btn-icon,
  .btn-outline-secondary {
    height:                       36px;
  }

  .btn-icon {
    @include                       border_radius(50%);
    width:                         36px;
    padding:                       0;
    margin:                        0 10px;
    border:                        1px solid var(--Shades-30-Border);
    &:hover svg,
    &:focus svg {
      stroke:                      inherit;
    }
  }

  .btn-outline-secondary {
    margin:                        0;
  }

  .logo {
    visibility:                    hidden;
  }

  .search-box {
    @include                       border_radius(28px);
    position:                      relative;
    width:                         100%;
    max-width:                     750px;
    background:                    var(--Shades-W);
    border:                        1px solid var(--Shades-20-Border);
    top:                           0;

    .form-group {
      display:                     flex;
      flex-direction:              row;
      align-items:                 center;
      justify-content:             space-between;
      gap:                         10px;
      width:                       100%;
      height:                      46px;
      margin:                      0;
      padding:                     0 20px 0 13px;
    }

    .form-control {
      color:                       var(--Shades-50);
      font-size:                   var(--font-size-14);
      font-weight:                 400;
      line-height:                 normal;
      letter-spacing:              0.7px;
      text-overflow:               ellipsis;
      overflow:                    hidden;
      width:                       calc(100% - 35px) !important;
      height:                      46px;
      padding:                     0;
      background:                  var(--Shades-W);
      border:                      0;

      &:focus {
        @include                   box_shadow(unset);
        outline:                   unset;
      }
    }

    .clear-search {
      margin-right:                10px;
    }

    .search-box-actions {
      svg {
        vertical-align:            text-top;
      }
    }

    .exam-filter-box {
      @include                     border_radius(0 0 28px 28px);
      @include                     box_shadow(0px 2px 4px 0px rgba(0, 0, 0, 0.10));
      position:                    absolute;
      width:                       100.5%;
      height:                      100%;
      max-height:                  0px;
      background:                  var(--Shades-BG);
      border:                      1px solid var(--Shades-20-Border);
      border-top:                  0;
      visibility:                  hidden;
    }

    p {
      color:                       var(--Shades-50);
      font-size:                   var(--font-size-14);
      font-weight:                 400;
      line-height:                 normal;
      letter-spacing:              0.7px;
      text-transform:              capitalize;
      text-align:                  left;
      width:                       100%;
    }

    .patient-list-box {
      .list-group {
        padding:                   40px 10px 15px;
      }
    }

    .list-group-box {
      @include                     border_radius(0 0 28px 28px);
      @include                     box_shadow(0px 2px 4px 0px rgba(0, 0, 0, 0.10));
      position:                    absolute;
      width:                       100.5%;
      height:                      100%;
      max-height:                  0px;
      background:                  var(--Shades-W);
      border:                      1px solid var(--Shades-20-Border);
      border-top:                  0;
      visibility:                  hidden;

      > div:first-child:not(.patient-list-box),
      .list-group-item {
        display:                   flex;
        flex-direction:            row;
        align-items:               center;
        gap:                       10px;
      }

      > div:first-child:not(.patient-list-box) {
        justify-content:           flex-start;
        flex-wrap:                 wrap;
        padding:                   40px 10px 20px 20px;
      }

      .list-group-item {
        padding:                   5px;

        .id-box {
          display:                 flex;
          gap:                     5px;
          margin:                  5px 0 0 5px;

          span {
            color:                 var(--Shades-70);
            font-size:             var(--font-size-12);
            font-weight:           400;
            line-height:           normal;
            letter-spacing:        0.6px;
          }
        }

        > div {
          flex:                    1;
        }

        small {
          color:                   var(--Shades-70);
          font-size:               var(--font-size-10);
          font-weight:             700;
          line-height:             normal;
          letter-spacing:          0.5px;
        }

        &:last-child {
          margin-bottom:           0;
        }
      }

      .search-all-box {
        display:                   flex;
        flex-direction:            row;
        align-items:               center;
        justify-content:           flex-start;
        gap:                       10px;
        padding:                   15px 15px 20px;
        border-top:                1px solid var(--Shades-40);

        p {
          color:                   var(--Shades-70);
          font-size:               var(--font-size-14);
          font-weight:             400;
          line-height:             normal;
          letter-spacing:          0.7px;
          flex:                    1;
        }

        small {
          color:                   var(--Shades-70);
          font-size:               var(--font-size-10);
          font-weight:             400;
          line-height:             normal;
          letter-spacing:          0.5px;
        }
      }
    }

    ul {
      list-style-type:             none;
      height:                      100%;
      margin-bottom:               0;
      overflow-y:                  auto;

      li {
        @include                   border_radius(0);
        margin-bottom:             17px;
        background:                var(--Shades-W);
        border:                    0;
        cursor:                    pointer;

        p {
          color:                   var(--Shades-70) !important;
          font-size:               var(--font-size-14);
          font-weight:             400;
          line-height:             normal;
          letter-spacing:          0.7px;
        }

        span {
          font-size:               var(--font-size-12);
        }

        &:hover,
        &:focus,
        &:active {
          background:              var(--Shades-10);
        }
      }
    }

    &.open {
      @include                     border_radius(28px);

      .list-group-box {
        max-height:                282px;
        top:                       27px;
        left:                      -1px;
        visibility:                visible;
        z-index:                   -1;

        ul {
          max-height:              220px;
        }

        &,
        ul {
          height:                  auto;
        }
      }

      .exam-filter-box {
        height:                    500px;
        max-height:                500px;
        top:                       27px;
        left:                      -1px;
        visibility:                visible;
        z-index:                   -1;
      }
    }
  }
}

.dark-theme {
  header {
    h1 {
      background:                  linear-gradient(90deg, #A8FFEF 0.02%, #3CB391 99.98%);
      background-clip:             text;
      -webkit-background-clip:     text;
      -webkit-text-fill-color:     transparent;
    }
  }
}

.retract {
  header {
    width:                         100%;

    .logo {
      visibility:                  visible;
    }
  }
}

.storage-box {
  flex-direction:                  column;
  gap:                             5px;
  padding:                         11px 10px;
  margin-right:                    10px;
  p {
    color:                         var(--Brand-Primary);
    text-align:                    center;
    font-size:                     var(--font-size-10);
    font-weight:                   500;
    line-height:                   normal;
    letter-spacing:                2.15px;
    text-transform:                uppercase;
    margin:                        0;
  }

  .progress-box {
    margin:                        0;
  }
}

input:focus::placeholder {
  color: transparent;
}

@media screen and (min-width: 992px) and (max-width: 1365px) {
  header {
    > div {
      &:first-child {
        gap:                       10px;
      }

      .clinic-box {
        max-width:                 400px;

        h1 {
          white-space:             nowrap;
        }
      }
    }
  }
}

@media (min-width: 1650px) {
  header .search-box {
    // max-width:                     750px;
    .exam-filter-box,
    .list-group-box {
      width:                       100.3%;
    }
  }
}
</style>

<script>
import { useUserStore } from '@/store/user'
import { useExamFilterStore } from '@/store/examFilter';
import { watch } from 'vue'

import ClinicChangeOffcanvas from './clinic/ClinicChangeOffcanvas.vue'
import ExamFilter from './exam/ExamFilter.vue'
import PatientListSearchedOffcanvas from './patient/PatientListSearchedOffcanvas.vue'
import MenuProfile from './menu/MenuProfile.vue'
//import MenuStorageBar from './menu/MenuStorageBar.vue'

export default {
  name: 'HomeHeader',
  components: {
    ClinicChangeOffcanvas,
    ExamFilter,
    PatientListSearchedOffcanvas,
    MenuProfile,
    //MenuStorageBar
  },
  data: () => ({
    session: {
      collaborator: {},
      currentClinic: {}
    },
    isPaidService: false,
    searchValue: '',
    headerPatientList: {},
    isExamFilter: false,
    locale: null,
    isExamRoute: false,
    showLatestResults: false,
    examFilter: null,
    // hasFilterItems: false,
    // patientFullName: '',
    debouncedSearch: null,
    examFilterStore: useExamFilterStore(),
    // currentFilter: {},
    isSmallScreen: false,
    isLoadingPatients: false,
    isSpecialist: false
  }),
  watch: {
    $route(to, from) {
      if (to.name == 'exam-list')
        this.isExamRoute = true
      else
        this.isExamRoute = false
    },
    // hasFilterItems(newValue) {
    //   if (newValue) {
    //     document.body.classList.add('has-filter');
    //   } else {
    //     document.body.classList.remove('has-filter');
    //   }
    // },
    // 'examFilterStore.filter': {
    //   handler(newFilterValue) {
    //     if (this.isSmallScreen) {
    //       return
    //     }
    //
    //     const newInnerFilter = newFilterValue.filter;
    //
    //     const hasDateFilters = newInnerFilter.startDate || newInnerFilter.endDate;
    //     const hasPropertiesFilters = newInnerFilter.properties && Object.keys(newInnerFilter.properties).some(key =>
    //       (key !== 'startDate' && key !== 'endDate' && typeof newInnerFilter.properties[key] === 'boolean' && newInnerFilter.properties[key] === true)
    //     )
    //
    //     this.hasFilterItems = !!(
    //       newInnerFilter.patientID ||
    //       hasDateFilters ||
    //       hasPropertiesFilters
    //     );
    //   },
    //   deep: true,
    // },
    'examFilterStore.filter.shouldCloseFilter': {
      handler(newValue) {
        if (this.isSmallScreen) {
          return
        }

        if (newValue === true) {
          this.closeExamFilterBox()
          this.examFilterStore.refreshFilter({ shouldCloseFilter: false })
        }
      },
      immediate: false,
      deep: false
    }
  },
  computed: {
    helpcenterUrl() {
      if (this.locale == 'pt-br')
        return 'https://phelcom.com/pt-br/helpcenter/'

      return 'https://phelcom.com/helpcenter/'
    },
    currentFilter() {
      return this.examFilterStore.filter.filter;
    },
    patientFullName() {
      return this.examFilterStore.filter.filter.patientFullName || '';
    },
    hasFilterItems() {
      const newInnerFilter = this.examFilterStore.filter.filter;
      const hasDateFilters = newInnerFilter.startDate || newInnerFilter.endDate;
      const hasPropertiesFilters = newInnerFilter.properties && Object.keys(newInnerFilter.properties).some(key =>
        (key !== 'startDate' && key !== 'endDate' && typeof newInnerFilter.properties[key] === 'boolean' && newInnerFilter.properties[key] === true)
      );

      if (newInnerFilter.patientID || hasDateFilters || hasPropertiesFilters) {
        document.body.classList.add('has-filter');
      } else {
        document.body.classList.remove('has-filter');
      }

      return !!(
        newInnerFilter.patientID ||
        hasDateFilters ||
        hasPropertiesFilters
      );
    },
  },
  mounted() {
    const userStore = useUserStore()

    this.isExamRoute = this.$router.currentRoute._value.name == 'exam-list'
    this.session = userStore.sessionInfo
    this.locale = this.session.currentClinic.locale.toLowerCase()
    this.isPaidService = this.$utils.getIsPaidService()
    this.isSpecialist = this.session.isSpecialist

    document.addEventListener('click', this.handleClickOutside);
    window.addEventListener('resize', this.handleResize);
    this.handleResize();

    this.debouncedSearch = _.debounce(this.fetchPatients, 300);
  },
  beforeUnmount() {
    document.removeEventListener('click', this.handleClickOutside);
  },
  methods: {
    handleClickOutside(event) {
      if ((this.isExpanded || this.showLatestResults) && this.$refs.searchBox && !this.$refs.searchBox.contains(event.target)) {
        this.isExpanded = false;
        this.showLatestResults = false
        this.searchValue = ''
        this.headerPatientList = {}
      }
    },
    handleResize() {
      this.isSmallScreen = window.innerWidth < 992;
    },
    doSearch(event) {
      if (event && (event.key === 'ArrowLeft' || event.key === 'ArrowRight'))
        return

      this.debouncedSearch(this.searchValue);
    },
    async fetchPatients(partialName) {
      this.showLatestResults = false

      if (!partialName || partialName.length < 3) {
        this.headerPatientList = {};
        return;
      }

      this.loading = true;
      NProgress.start();
      try {
        const params = { partialName };
        const response = await this.$patientService.searchPatient(params);

        this.headerPatientList = response.result || {};
      } catch (err) {
        this.$message.popup(this, 'request_error', 'operationFail', 'error');
        // this.alert = this.$message.alert(this, 'request_error', 'danger');
      } finally {
        NProgress.done(true);
        this.loading = false;
      }
    },
    toPatientDetails(item) {
      this.searchValue = ''
      this.headerPatientList = {}

      //this.$router.push({name: 'patient-show', params: {patientID: item.id}, query: {tab: 'data'}})

      this.$router.push({name: 'patient-show', params: {patientID: item.id}, query: {tab: 'exams'}})
    },
    toExamDetails(event, item) {
      event.stopPropagation()
      let data = null
      this.searchValue = ''
      this.headerPatientList = {}
      //this.$router.push({name: 'patient-show', params: {patientID: item.id}, query: {tab: 'data'}})

      this.$router.push({ name: 'exam-show', params: { examID: item.id }, query: { tab: 'images', data: data } })
    },
    toggleExamFilter() {
      this.isExamFilter = !this.isExamFilter

      if (this.isExamFilter)
        this.clearSearchValue()
    },
    formatDate(date) {
      return moment(date).format(this.$i18n.t('dateTimeFormat'))
    },
    async openChangeOffcanvas() {
      const ok = await this.$refs.clinicChangeOffcanvas.show({})
      if (ok) {}
    },
    updateExamFilter(payload) {
      const examFilterStore = useExamFilterStore();
      const currentInnerFilter = examFilterStore.filter.filter;

      const mergedFilter = {
        ...currentInnerFilter,
        ...payload.filter
      };

      const finalPayload = {
        ...payload,
        filter: mergedFilter
      };

      examFilterStore.refreshFilter(finalPayload);

      this.showLatestResults = false;
      this.searchValue = null;
      this.headerPatientList = {};

      sessionStorage.setItem('examFilters', JSON.stringify(examFilterStore.filter))
      this.$router.push('/exam/')
    },
    doFilterExamListByPatientID(item) {
      this.updateExamFilter({
        filter: {
          patientID: item.id,
          patientFullName: item.fullName
        },
        newRequest: true
      });
    },
    doFilterExamListLastSevenDays() {
      const startDate = moment().subtract(7, 'days').toDate();
      const endDate = moment().toDate();

      const currentFilter = this.examFilterStore.filter.filter;

      const payloadFilter = {
        ...currentFilter,
        startDate: this.$utils.formatDate(this, startDate),
        endDate: this.$utils.formatDate(this, endDate)
      };

      this.updateExamFilter({
        filter: payloadFilter,
        newRequest: true
      });
    },

    clearFilteredList(filterKey) {
      const examFilterStore = useExamFilterStore()
      const currentTopLevelFilter = examFilterStore.filter
      const currentInnerFilter = currentTopLevelFilter.filter

      if (filterKey === 'all') {
        this.hasFilterItems = false
        examFilterStore.reset()
        examFilterStore.refreshFilter({ newRequest: true })
        return
      }

      let filterUpdates = { ...currentInnerFilter };
      let updatedProperties = { ...(currentInnerFilter.properties || {}) };

      switch (filterKey) {
        case 'name':
          filterUpdates.patientID = null
          filterUpdates.patientFullName = null
          break
        case 'date':
          filterUpdates.startDate = null
          filterUpdates.endDate = null
          break;
        case 'mcRas':
        case 'color':
        case 'redfree':
        case 'infrared':
        case 'segAnterior':
        case 'panoramic':
        case 'stereo':
        case 'eyermaps':
          updatedProperties[filterKey] = false
          filterUpdates.properties = updatedProperties
          break
        default:
         console.warn(`Unknown filter item: ${filterKey}`)
         return
      }

      this.updateExamFilter({ filter: filterUpdates, newRequest: true })
    },
    clearSearchValue() {
      this.searchValue = ''
      // this.showLatestResults = true
      this.headerPatientList = {}
    },
    async showAllSearchedPatients() {
      if (this.searchValue.length < 3)
        return

      this.isLoadingPatients = true
      const partialPatientName = this.searchValue

      const ok = await this.$refs.patientListSearchedHeaderOffcanvas.show({
        patientName: partialPatientName,
      })
      if (ok) {
        this.doFilterExamListByPatientID(ok);
      }

      this.isLoadingPatients = false
    },
    handleInputClick() {
      if (Object.keys(this.headerPatientList).length > 0) {
        return
      }

      // this.showLatestResults = true;
    },
    closeExamFilterBox() {
      this.showDateFilter = false
      this.searchMode = 'patient'
      this.isExpanded = false
      this.isExamFilter = false
      this.clearSearchValue()
    },
  }
}
</script>
